"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiConstructor = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Base = require("../config/Base");

var xJmmAuth = function xJmmAuth(cognitoUser, authConfig) {
  var authUser = "CognitoIdentityServiceProvider.".concat(authConfig.userPoolWebClientId, ".LastAuthUser");
  var keyPrefix = "CognitoIdentityServiceProvider.".concat(authConfig.userPoolWebClientId, ".").concat(cognitoUser.getUsername());
  var signInUserSession = cognitoUser.getSignInUserSession();
  var auth = {};
  auth["".concat(keyPrefix, ".idToken")] = signInUserSession.getIdToken().getJwtToken();
  auth["".concat(keyPrefix, ".accessToken")] = signInUserSession.getAccessToken().getJwtToken();
  auth["".concat(keyPrefix, ".refreshToken")] = signInUserSession.getRefreshToken().getToken();
  auth["".concat(keyPrefix, ".clockDrift")] = String(signInUserSession.getClockDrift());
  auth[authUser] = cognitoUser.getUsername();

  if (localStorage.getItem('bcUuidOverride')) {
    auth['bcUuidOverride'] = localStorage.getItem('bcUuidOverride');
  }

  return encodeURIComponent(JSON.stringify(auth));
};

var ApiConstructor = function ApiConstructor(amplifyConfig, loadAuth) {
  var customConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var loadApi = function loadApi() {
    return import(
    /* webpackChunkName: 'amplifyApi' */
    '@aws-amplify/api').then(function (module) {
      var a = new module.APIClass();
      a.configure((0, _extends2.default)({}, amplifyConfig, {
        graphql_headers: graphql_headers
      }));
      return a;
    });
  };

  var getRestAuthorizationHeaders = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var auth, user, session, overrideHeader;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return loadAuth();

            case 3:
              auth = _context.sent;
              _context.next = 6;
              return auth.currentAuthenticatedUser();

            case 6:
              user = _context.sent;
              _context.next = 9;
              return auth.currentSession();

            case 9:
              session = _context.sent;
              overrideHeader = customConfig.bcIdOverride ? (0, _defineProperty2.default)({}, customConfig.bcIdOverride, localStorage.getItem('bcUuidOverride')) : {};
              return _context.abrupt("return", (0, _extends2.default)({
                Accept: 'application/json',
                'X-JMM-Auth': xJmmAuth(user, amplifyConfig.Auth)
              }, overrideHeader, {
                Authorization: session.getIdToken().getJwtToken()
              }));

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.warn(_context.t0);
              return _context.abrupt("return", {});

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    return function getRestAuthorizationHeaders() {
      return _ref.apply(this, arguments);
    };
  }();

  var graphql_headers = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var auth, session;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return loadAuth();

            case 3:
              auth = _context2.sent;
              _context2.next = 6;
              return auth.currentSession();

            case 6:
              session = _context2.sent;
              return _context2.abrupt("return", {
                Authorization: session.getIdToken().getJwtToken()
              });

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.warn(_context2.t0);
              return _context2.abrupt("return", {});

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function graphql_headers() {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    cognitoToken: function () {
      var _cognitoToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var auth;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return loadAuth();

              case 2:
                auth = _context3.sent;
                _context3.next = 5;
                return auth.currentSession();

              case 5:
                return _context3.abrupt("return", _context3.sent.getAccessToken().getJwtToken());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function cognitoToken() {
        return _cognitoToken.apply(this, arguments);
      }

      return cognitoToken;
    }(),
    authHeader: function () {
      var _authHeader = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var auth;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return loadAuth();

              case 2:
                auth = _context4.sent;
                _context4.next = 5;
                return auth.currentSession();

              case 5:
                return _context4.abrupt("return", _context4.sent.getIdToken().getJwtToken());

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function authHeader() {
        return _authHeader.apply(this, arguments);
      }

      return authHeader;
    }(),
    auth: loadAuth,
    get: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
        var optionalHeaders,
            api,
            authHeaders,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                optionalHeaders = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                _context5.next = 3;
                return loadApi();

              case 3:
                api = _context5.sent;
                _context5.next = 6;
                return getRestAuthorizationHeaders();

              case 6:
                authHeaders = _context5.sent;
                return _context5.abrupt("return", api.get(_Base.apiEndpoint, url, {
                  headers: (0, _extends2.default)({}, authHeaders, optionalHeaders)
                }));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }(),
    post: function () {
      var _post = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url, body) {
        var optionalHeaders,
            api,
            authHeaders,
            _args6 = arguments;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                optionalHeaders = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                _context6.next = 3;
                return loadApi();

              case 3:
                api = _context6.sent;
                _context6.next = 6;
                return getRestAuthorizationHeaders();

              case 6:
                authHeaders = _context6.sent;
                return _context6.abrupt("return", api.post(_Base.apiEndpoint, url, {
                  headers: (0, _extends2.default)({}, authHeaders, optionalHeaders),
                  body: body
                }));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function post(_x2, _x3) {
        return _post.apply(this, arguments);
      }

      return post;
    }(),
    delete: function () {
      var _delete2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url, body) {
        var optionalHeaders,
            api,
            authHeaders,
            _args7 = arguments;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                optionalHeaders = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
                _context7.next = 3;
                return loadApi();

              case 3:
                api = _context7.sent;
                _context7.next = 6;
                return getRestAuthorizationHeaders();

              case 6:
                authHeaders = _context7.sent;
                return _context7.abrupt("return", api.del(_Base.apiEndpoint, url, {
                  headers: (0, _extends2.default)({}, authHeaders, optionalHeaders),
                  body: body
                }));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function _delete(_x4, _x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }(),
    graphql: function () {
      var _graphql = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(options) {
        var api;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return loadApi();

              case 2:
                api = _context8.sent;
                return _context8.abrupt("return", api.graphql(options));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function graphql(_x6) {
        return _graphql.apply(this, arguments);
      }

      return graphql;
    }(),
    graphql_headers: graphql_headers
  };
};

exports.ApiConstructor = ApiConstructor;